/**
 * 首件检store
 */
// import { message } from 'ant-design-vue'
let store = {
  state: {
    //当前待首件检工单
    firstInspectInfo: null,
    //当前首件检单
    firstSheet: null,
    //检验方案
    firstCheckProject: null,
    //检验项目集合
    firstCategoryList: [],
    //检验记录列表
    firstRecordList: [],
    //表单
    firstInspectFormData: {
      batchCode: undefined
    },
    //首件检类型 BATCH：批次 WORK_ORDER：工单
    firstInspectSourceType: null
  },
  mutations: {
    setFirstInspectInfo(state, firstInspectInfo){
      state.firstInspectInfo = firstInspectInfo
    },
    setFirstSheet(state, firstSheet){
      state.firstSheet = firstSheet
    },
    setFirstCheckProject(state, firstCheckProject){
      state.firstCheckProject = firstCheckProject
    },
    setFirstCategoryList(state, firstCategoryList){
      state.firstCategoryList = firstCategoryList
    },
    setFirstRecordList(state, firstRecordList){
      state.firstRecordList = firstRecordList
    },
    setFirstInspectSourceType(state, firstInspectSourceType){
      state.firstInspectSourceType = firstInspectSourceType
    },
  },
  actions:{
    // 检查是否存在检验工单
    // async waitInspectBySheetExist({state}){
    //   if(!state.waitInspectBySheet){
    //     message.warn("请先选中待检工单!")
    //     return false
    //   }
    //   return true
    // },
    // 新增检验记录
    addFirstRecord({state, getters}){
      let record = new CheckRecordEntity(getters.getFirstAllRuleList, state.lastSerialNum)
      state.firstRecordList.push(record)
    },
    // 删除检验记录
    delFirstRecord({state, getters}, key){
      state.firstRecordList.splice(getters.getFirstRecordList.findIndex(item => item.key == key), 1)
    },
    // 重置检验相关数据
    resetFirstInspectDatas(placeholder, {checkProject, categoryList, recordList}){
      this.commit('setFirstCheckProject', checkProject)
      this.commit('setFirstCategoryList', categoryList)
      this.commit('setFirstRecordList', recordList)
    },
  },
  getters:{
    // 获取当前首件检工单
    getFirstInspectInfo(state){
      return state.firstInspectInfo || {}
    },
    // 获取当前首件检工单id
    getFirstInspectInfoId(state){
      return state.firstInspectInfo?.id
    },
    // 获取当前首件检单
    getFirstSheet(state){
      return state.firstSheet || {}
    },
    // 获取检验方案
    getFirstCheckProject(state){
      return state.firstCheckProject || {}
    },
    // 获取检验项目列表
    getFirstCategoryList(state){
      return state.firstCategoryList || []
    },
    // 获取检验方案中的所有检验项列表
    getFirstAllRuleList(state, getters){
      let ruleList = []
      getters.getFirstCategoryList.forEach(category => 
        ruleList.push(...category.ruleList)
      )
      return ruleList
    },
    // 获取检验方案sip列表
    getFirstSipList(state, getters){
      return getters.getFirstCheckProject.documentList || []
    },
    // 获取检验记录列表
    getFirstRecordList(state){
      state.firstRecordList || (state.firstRecordList = [])
      return state.firstRecordList
    },
  }
}

export default {
  ...store
}

function CheckRecordEntity(allRuleList, serialNum){
  let serial = 10000
  this.serialNum = serial + serialNum
  this.serialRank = serialNum
  this.checkRuleList = allRuleList.map(rule => {
    //检验次数
    let count = rule.count || 1
    //根据检验次数生成输入框
    let inputValueList = []
    for(let i = 0 ; i < count ; i++){
      inputValueList.push(new InputValue())
    }
    return {
      ruleCode: rule.code,
      ruleName: rule.name,
      inputValueList
    }
  })
}

function InputValue(){
  this.value = undefined
}